import { render, staticRenderFns } from "./TechInfo.vue?vue&type=template&id=7cb58ab7&"
import script from "./TechInfo.vue?vue&type=script&lang=js&"
export * from "./TechInfo.vue?vue&type=script&lang=js&"
import style0 from "./TechInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports